/** @jsx jsx */

import React, { useState, useEffect } from 'react';
import { css, jsx } from '@emotion/core';
import { connect } from 'react-redux';
import Modal from 'components/UI/Modal';
import { Box } from '@chameleoncreator/creator-ui';
import Interactions from './Interactions';
import { ThemeProvider } from 'emotion-theming';
import { theme } from 'theme';
import { getLocation, getSuspendData } from 'services/scorm/scormService';
import getStore from 'services/getStore';
import getTopics from 'services/apiHelpers/getTopics';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import EditorBtn from 'components/UI/EditorBtn';
import setCurrentTopic from 'services/apiHelpers/setCurrentTopic';
import { rehydrateFromLMSAction } from 'store/next';
import { clearLocationHistory } from 'services/clearLocationHistory';

const store = getStore();

const Bookmark = () => {
  const [bookmark, setBookmark] = useState(null);

  const {
    textColor,
    buttonBackgroundColor,
    buttonTextColor,
    fontFamily,
  } = store.getState().theme;

  useEffect(() => {
    const location = getLocation(); // true for testing local

    // testing this as 1/1
    // but need to calculate what the actual first topic / interaction is

    const firstTopic: any = getTopics()[0];
    const firstInteraction: any = getInteractionsInTopic(firstTopic)[0];

    if (!firstTopic || !firstInteraction) {
      return;
    }

    const firstTopicSId = firstTopic.props.sId || firstTopic.id;
    const firstInteractionSId =
      firstInteraction.props.sId || firstInteraction.id;

    if (location && location !== `${firstTopicSId}/${firstInteractionSId}`) {
      setBookmark(location);
    }
  }, []);

  return bookmark ? (
    <ThemeProvider theme={theme}>
      <Modal onClose={() => setBookmark(null)}>
        <Box
          className="fader_-5s"
          css={css`
            padding: 50px;
          `}
        >
          <Box
            css={css`
              margin: 20px 0;
            `}
          >
            <h4
              css={css`
                text-align: center;
                color: ${textColor};
              `}
            >
              Would you like to return to where you left off?
            </h4>
          </Box>
          <Box
            css={css`
              display: flex;
              justify-content: center;
            `}
          >
            <div
              css={css`
                display: flex;
              `}
            >
              <EditorBtn
                label="YES"
                css={css`
                  margin: 0 20px;
                  background: ${buttonBackgroundColor};
                  color: ${buttonTextColor};
                  // font-family: ${fontFamily};
                `}
                onClick={() => {
                  window.location.hash = bookmark;

                  requestAnimationFrame(() => {
                    clearLocationHistory();
                    setBookmark(null);
                  });
                }}
              />

              <EditorBtn
                label="NO"
                css={css`
                  margin: 0 20px;
                  background: ${buttonBackgroundColor};
                  color: ${buttonTextColor};
                  // font-family: ${fontFamily};
                `}
                onClick={() => {
                  setCurrentTopic(getTopics()[0].id);
                  setBookmark(null);
                }}
              />
            </div>
          </Box>
        </Box>
      </Modal>
    </ThemeProvider>
  ) : null;
};

export default Bookmark;
